import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";
import { FirmaRemotaModal } from "../../firmaremota/modal";

export interface Params {
    idFirma: string;
    folios: string[];
}

export interface Props extends kea.ModalProps<undefined, boolean, Params> {

}


/**
* Modal de edición para un Modal
*/
export class EntregaOcurreModal extends React.PureComponent<Props> {
    modalManager = kea.createModalManager();

    onRevisarFirma = async () => {
        const firma = await resources.FirmaRemota.Get(this.props.params.idFirma);
        if (firma.FirmaUsuario == null) {
            await kea.message("Firma no capturada", "Aún no se ha capturado la firma", "error");
        } else {
            this.props.onClose(true);
        }
    };

    onCapturarAqui = async () => {
        const result = await this.modalManager.showModal(FirmaRemotaModal, { id: this.props.params.idFirma }, undefined);
        if (result.result) {
            await this.onRevisarFirma();
        }
    }

    onCerrar = () => {
        this.props.onClose(false);
    }
    render() {
        const url = "/operativa/firmaremota/" + this.props.params.idFirma;
        const QR = "go:" + url;
        const value = this.props.value;
        return (
            <kea.Modal
                buttons={[
                    <kea.Button style="info" onClick={this.onCapturarAqui} iconClass={fa("pencil-square-o")}>
                        Firmar en este dispositivo
                    </kea.Button>,
                    <kea.Button style="success" onClick={this.onRevisarFirma} iconClass={fa("mobile")} >
                        Firma capturada en otro dispositivo
                    </kea.Button>]}
                onClose={this.onCerrar}
                title="Capture firma del cliente"
            >
                <div>
                    <label>Para firmar en otro dispositivo:</label>
                    <ol>
                        <li>Escanee el siguiente QR para capturar la firma del cliente</li>
                        <li>Una vez capturada de click en <b>Firma capturada en otro dispositivo</b>  </li>
                    </ol>
                </div>

                <kea.QRCode value={QR} size={256} />

                {this.modalManager.component}
            </kea.Modal>
        )
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/ocurre/componentes/firmar.tsx